import axios from 'axios'
// import Common from '@/components/common'

export const postRequestWx = (url, params, headKey, timespankey) => {
  return axios({
    method: 'post',
    url: url,
    data: params,
    headers: {
      'Content-Type': 'application/json',
      feedBackSign: headKey,
      wxminiapitimespan: timespankey
    }
  })
}
export const getRequestWx = (url, params) => {
  return axios({
    method: 'get',
    url: url,
    params: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/utilsWx.js